module.exports = __webpack_public_path__ + "img/marker-nodisc-purple.f62fa383.png";